export default __webpack_public_path__ + "static/media/assetCapture.svg";